import React from 'react';
import { useHistory } from 'react-router-dom';
import { throttle } from '../../../lib/utils';
import { HeaderButton } from './HeaderButton';

export const BackButton: React.FC<{
  background?: string;
  onClick?: () => void;
  ariaLabel: string;
}> = ({ background, onClick, ariaLabel }) => {
  const history = useHistory();
  const handleClick = throttle(() => history.goBack(), 1000);
  return (
    <HeaderButton ariaLabel={ariaLabel} background={background} onClick={onClick || handleClick}>
      <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        xmlns="http://www.w3.org/2000/svg"
        style={{ paddingRight: '2px' }}
      >
        <path
          d="M0.299809 7.56678C0.300849 7.15217 0.473452 6.75649 0.776636 6.47367L7.17664 0.50371C7.78242 -0.0613692 8.7316 -0.0283721 9.29667 0.577413C9.86176 1.1832 9.82876 2.13237 9.22297 2.69745L3.99296 7.57604L9.22821 12.5089C9.83115 13.077 9.85939 14.0263 9.29128 14.6292C8.72316 15.2322 7.77384 15.2604 7.17089 14.6923L0.771147 8.66227C0.469386 8.37794 0.298769 7.98139 0.299809 7.56678Z"
          fill="#897A66"
        />
      </svg>
    </HeaderButton>
  );
};
